module.exports = __webpack_public_path__ + "img/girl-intervue.d51f9e5.jpg";